import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  private baseUrl = environment.baseUrl
  private resource: string = 'mensagem-template'

  constructor(private httpClient: HttpClient) {
  }


  public createMessage(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }

  public editMessage(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.put<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/update/${model.id}`,
      model,
    )
  }

  public deleteMessage(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.delete<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete/${model}`)
  }

  public listPagedMessage(
    page: number,
    rows: number = 15,
    tipo_uso: any = null
  ): Observable<ResponseRequestModel> {
    let params = ''
    if(tipo_uso){
      params += "&tipo_uso="+tipo_uso
    }
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/list?page=${page}&per_page=${rows}${params}`,
    )
  }

  public useTypes(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/tipos`,
    )
  }

  public listMessage(params: string = ''): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/list${params}`,
    )
  }

  public searchPagedLocation(
    page: number,
    rows: number = 15,
    model: any,
    tipo_uso: any = null
  ): Observable<ResponseRequestModel> {

    let params = ''

    if (model?.nome?.length > 0) {
      params += `&nome=${model.nome}`
    }

    if (model?.texto?.length > 0) {
      params += `&texto=${model.texto}`
    }
    if(tipo_uso){
      params += `&tipo_uso=${tipo_uso}`
    }

    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/list?page=${page}&per_page=${rows}${params}`,
    )
  }


  public searchLocationCityState(
    // model: SearchLocationModel,
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search/cidade-estado`,
      model,
    )
  }

  public getLocationbyId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }

  // public searchPagedLocation(
  //   page: number,
  //   rows: number = 15,
  //   model: any,
  //   // model: SearchLocationModel,
  // ): Observable<ResponseRequestModel> {
  //   return this.httpClient.post<ResponseRequestModel>(
  //     `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
  //     model,
  //   )
  // }
// }
}
